// extracted by mini-css-extract-plugin
module.exports = {"article":"BlogArticle_article__x9kYv"};